export default {
  data() {
    return {
    };
  },
  props: ['title', 'client', 'last_action', 'stage', 'percentage'],
  template: '<div class="deal shadow clickable">' +
    '<div class="title">{{ title | truncate(20) }}</div>' +
    '<div class="client">{{ client.name | truncate(20) }}</div><br/><br/>' +
    '<span class="last_action">' +
    '<strong>{{ $t(\'last-activity\') }}</strong><br/>' +
    '{{ last_action | relativeTime }}</span>' +
    '<br/><br/>' +
    '<span class="stage"><strong>{{ $t(\'stage\') }}</strong><br/>{{ stage.title }}</span>' +
    '<br/><br/>' +
    '<div class="stage-progress">' +
    '<div class="progress-fill" v-bind:style="{width: percentage + \'%\'}"></div>' +
    '</div></div>',
};



// WEBPACK FOOTER //
// ./src/components/Deal.js